export const OPERATION_TYPE = process.env.REACT_APP_ENVIRONMENT; //"DEV"; // STAGE, PROD , DEV, TEST
export const GIVE_ACCESS_TO_ROLE = "Issuer";
export const LANDING_URL = "/issuer/dashboard";
export const UNAUTHORIZED_URL = "/public/user/auth";
export const MUST_CHANGE_PASSWORD_URL = "/issuer/user/change-password";
export const BASE_TITLE = " | SEINet Core ";

export const DEFAULT_LIST_PAGESIZE = 10;

export const API_SERVER = process.env.REACT_APP_API;

export const TIMEOUT_ALERT_IN_SECUNDES = 7;
export const TIMEOUT_REDIRECT_IN_SECUNDES = 7;
export const TIMEOUT_API_POST_IN_MILISECUNDES = 20000;
export const TIMEOUT_API_POST_EXTENDED_IN_MILISECUNDES = 30000;
export const TIMEOUT_API_POST_EXTRA_EXTENDED_IN_MILISECUNDES = 600000;

export const PASSWORD_STRENGHT = new RegExp(
  "^(?=.*[a-zа-ш])(?=.*[A-ZА-Ш])(?=.*[0-9])(?=.*[!@#$%\\^&\\*()\\-_=\\+\\{\\}\\[\\]:;\"',.<>\\/?\\|])(?=.{8,})"
);
export const EMAIL_RULE = new RegExp(
  "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$"
);
export const USERNAME_RULE = new RegExp("^[a-zA-Z0-9._]$");

export const MAX_FILE_SIZE_MB = 21;
